import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { queryKeys } from '~/api/queryKeys';
import { Button } from '~/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '~/components/ui/dialog';
import { useTaxonomyStudioStore } from '~/store/taxonomy-studio.store';

/**
 * 412 STALE_ITEM: someone saved the same item after this screen loaded it. The user
 * chooses: Reload (drop their edit, see the latest) or Overwrite (send their version
 * anyway, without `If-Match`). Opened from any `If-Match` write via the studio store.
 */
export function StaleItemDialog() {
  const { t } = useTranslation('taxonomy-studio');
  const qc = useQueryClient();
  const stale = useTaxonomyStudioStore((s) => s.stale);
  const setStale = useTaxonomyStudioStore((s) => s.setStale);

  return (
    <Dialog
      open={stale !== null}
      onOpenChange={(o) => {
        if (!o) setStale(null);
      }}
    >
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{t('stale.title')}</DialogTitle>
          <DialogDescription>{t('stale.body', { name: stale?.itemLabel ?? '' })}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            className="cursor-pointer"
            onClick={() => {
              setStale(null);
              void qc.invalidateQueries({ queryKey: queryKeys.taxonomyStudio.all });
            }}
          >
            {t('stale.reload')}
          </Button>
          <Button
            variant="destructive"
            className="cursor-pointer"
            onClick={() => {
              const overwrite = stale?.overwrite;
              setStale(null);
              overwrite?.();
            }}
          >
            {t('stale.overwrite')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
